//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "InnerPdf",
  props: {
    // 控制弹框显示
    innerPdfShow: {
      type: Boolean,
      default: false
    },
    // 标题
    title: {
      type: String,
      default: "提交"
    },
    // 关闭按钮文本
    closeText: {
      type: String,
      default: "关闭"
    },
    // 驳回的按钮文本
    rejectText: {
      type: String,
      default: "驳回"
    },
    // 签署按钮文本
    signText: {
      type: String,
      default: "确认签署并提交"
    },
    // 关闭按钮(显示隐藏)
    isCloseBtn: {
      type: Boolean,
      default: true
    },
    // 驳回按钮(显示隐藏)
    isRejectBtn: {
      type: Boolean,
      default: true
    },
    // 签署按钮(显示隐藏)
    isSubmitBtn: {
      type: Boolean,
      default: true
    },
    // 文件的blob对象url
    pdfBlobUrl: {
      type: String,
      dafault: ""
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    // 关闭弹框
    closeBox: function closeBox() {
      // console.log('关闭');
      this.$emit("update:innerPdfShow", false);
      this.$emit("close");
    },
    // 签署(签署之后需要父组件操作关闭弹框)
    sureSign: function sureSign(type) {
      // console.log('签署')
      // "1"表示通过，"2"表示驳回
      this.$emit("success", type); // this.$emit("update:innerPdfShow", false);
    }
  }
};